// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"ih-z","categoryName":"jh-z","categoryImage":"kh-z","categoryContent":"lh-z","bottomAligned":"mh-z"};